import {ClickerGCSEngine} from '../../ui/pages/ClickerGamePage/clicker-game/ClickerGame.types';
import {GCS_TOKENS} from './di.gcs.tokens';
import {INFRA_TOKENS} from './di.infra.tokens';
import {Point} from 'pixi.js';

import {Container, injected} from 'brandi';

import {
  HealthComponent,
  Movement2dComponent,
  Transform2dComponent,
  createSingletonGCSEngine,
} from '@specials/gcs-engine';

import {PixiRenderer} from '@/gcs/PixiRenderer';
import {PixiViewRendererComponent} from '@/gcs/PixiViewRendererComponent';

export function initGCSDeps(container: Container): void {
  container.bind(GCS_TOKENS.pixiRenderer).toInstance(PixiRenderer).inTransientScope();

  container
    .bind(GCS_TOKENS.gcsEngine)
    .toInstance(() => createSingletonGCSEngine(container.get(GCS_TOKENS.pixiRenderer)) as ClickerGCSEngine)
    .inSingletonScope();

  container.bind(GCS_TOKENS.pointFactory).toFactory(Point, (instance, x, y) => {
    instance.x = x || 0;
    instance.y = y || 0;
  });

  // components
  injected(HealthComponent, INFRA_TOKENS.callbackCollector);
  container.bind(GCS_TOKENS.healthComponent).toInstance(HealthComponent).inTransientScope();

  injected(Movement2dComponent, GCS_TOKENS.pointFactory);
  container.bind(GCS_TOKENS.movement2dComponent).toInstance(Movement2dComponent).inTransientScope();

  injected(Transform2dComponent, GCS_TOKENS.pointFactory);
  container.bind(GCS_TOKENS.transform2dComponent).toInstance(Transform2dComponent).inTransientScope();
  container.bind(GCS_TOKENS.transform2dComponentFactory).toFactory(Transform2dComponent);

  injected(PixiViewRendererComponent, GCS_TOKENS.gcsEngine);
  container.bind(GCS_TOKENS.pixiViewRendererComponent).toInstance(PixiViewRendererComponent).inTransientScope();
}
